module.exports = __webpack_public_path__ + "img/invoice.cac2591e.png";